import React from "react";
import Search from "components/search";
import { useMediaQuery } from "react-responsive";
import { SCREEN_SIZES } from "utils/constants";
import { useSettings } from "hooks/useStore";

const EmbeddedSearch = ({ data }) => {
	if (!data) return null;
	const { searchData, visibleOnDesktop, visibleOnMobile } = data;
	const { isClient } = useSettings(["isClient"]);
	const isMobile = useMediaQuery({ maxWidth: SCREEN_SIZES.md });

	if ((!isMobile && !visibleOnDesktop) ||
		(isMobile && !visibleOnMobile) || !isClient) return null;

	return (
		<div className="relative">
			<div className="container-fluid-padding">
				<Search data={searchData} isEmbedded isModule />
			</div>
		</div>
	);
};

export default EmbeddedSearch;